






















import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import LivingPlace from './LivingPlace.vue'
import OfflineMediate from './OfflineMediate.vue'

@Component({
	name: 'addOfflineMediate',
	components: {
		LivingPlace,
		OfflineMediate,
		PageLayout,
	},
})
export default class addTaskPage extends Vue {
	private active: any = '1'

	@Prop()
	private visible!: boolean

	private get isFirstVisit() {
		return this.active === '1'
	}

	private toggle(i: any) {
		this.active = i
	}

	private prevStep() {
		this.$emit('prevStep')
	}

	private created() {}
}
